import sessionEvents from 'events/session';

export default function updateCustomerUrl(customerUrl) {
  return (dispatch, getState, { sessionGateway, messageGateway }) => {
    const { gladlyCustomerId } = sessionGateway.getSession();

    dispatch(sessionEvents.updateSessionUrl(customerUrl));
    messageGateway.updateCustomerUrl(customerUrl, gladlyCustomerId);
  };
}
